<template>
    <div class="float-left mr-1">
        <span class="text-danger">
            <i
                class="fa fa-trash fa-lg icon-button"
                title="Excluir Seguro/Garantia"
                @click.stop="confirmarExcluir()"
            ></i>
        </span>
    </div>
</template>

<script>
import SegurosServicos from './SegurosServicos'

export default {
    props: {
        seguro: {
            type: Object,
            default: () => ({})
        },
    },

    data() {
        return {}
    },

    methods: {
        confirmarExcluir() {
            this.$swal({
                title: 'Seguros/Garantias',
                html: `Confirma a exclusão do Seguro/Garantia de Número da Apólice <b>${this.seguro.descricao}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.excluir()
                }
            })
        },

        excluir() {
            this.$store.dispatch('addRequest')
            let seguroDto = {
                idContrato: this.seguro.idContrato,
                idSeguroGarantiaContrato: this.seguro.idSeguroGarantiaContrato
            }
            SegurosServicos.excluir(seguroDto).then(response => {
                if (response) {
                    if (response.success) {
                        this.registroSalvoComSucesso()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        registroSalvoComSucesso() {
            this.$toast.success(
                'Registro excluído com sucesso!',
                'OK',
                this.$toastConfig.success
            )
            this.$emit('obterSegurosAtualizados')
        }
    },

    created() {},

    computed: {},

    watch: {},

    validations: {}
}
</script>
